import styled from "styled-components";

export const Container = styled.div`
  & .slick-slider {
    .slick-dots-common {
      bottom: 14px;
      li > button {
        &::before {
          font-size: 40px;
          color: #ffffff;
          background-color: rgba(128,128,128,1);
          border-radius: 10px;
        }
      }
    }
  }
`;
